import React from 'react';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

// L&R Logo component based on their branding
const LRLogo = () => (
  <div className="flex items-center space-x-3">
    <img
      src="/lr-logo-new.png"
      alt="L&R People.Health.Care. Logo"
      className="h-8 w-auto"
    />
  </div>
);

// User profile with logout button
const LogoutButton = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (!user) return null;

  // Get user role display
  const userRole = user.roles?.includes('admin') ? 'Admin' : 'User';

  return (
    <div className="flex items-center gap-3">
      <div className="text-right">
        <div className="text-sm font-semibold">{user.name || user.email}</div>
        <div className="text-xs text-muted-foreground">
          {user.email}
          {user.roles && user.roles.length > 0 && ` • ${userRole}`}
        </div>
      </div>
      <Button variant="ghost" onClick={handleLogout} className="h-12 w-12">
        <LogOut className="h-6 w-6 text-red-800" />
      </Button>
    </div>
  );
};

const Header = () => {
  return (
    <header className="h-12 bg-background border-b border-border flex items-center px-4">
      <SidebarTrigger className="mr-4" />
      <LRLogo />
      <div className="flex-1" /> {/* Spacer to push user menu to the right */}
      <LogoutButton />
    </header>
  );
};

export default Header;